import {
  readSharedResourceSignedRequest,
  SharedReportSignedUrlRequest,
  SharedResourceSignedRequestResult,
} from 'shared/download/sharedResourceSignedRequest';
import {
  buildSignedRequestUrlForReport,
  pullPublicLinkResponse,
  SharedResourceResponse,
} from '../signedRequest';
import { createAbortOnLogout } from 'serviceWorker/helpers/abortableServiceHandler';

let reportAbortOnLogout: ReturnType<typeof createAbortOnLogout> | null = null;

function pullReportResponse({
  reportId,
  token,
}: SharedReportSignedUrlRequest): Promise<SharedResourceResponse> {
  return pullPublicLinkResponse(reportAbortOnLogout, (setup) =>
    buildSignedRequestUrlForReport(setup, reportId, token)
  );
}

/** Signed URL(s) of a public report link, or the status the server refused it with. */
export async function getReportSignedUrl(
  request: SharedReportSignedUrlRequest
): Promise<SharedResourceSignedRequestResult> {
  const { statusCode, body } = await pullReportResponse(request);
  return readSharedResourceSignedRequest(statusCode, body);
}

export const init = (): void => {
  // Concurrent: a new public link request must not abort one in flight.
  reportAbortOnLogout = createAbortOnLogout('concurrent');
};
